import React from "react";
import { connect } from "react-redux";
import { Row, Col, Pagination, Select } from "antd";
import { Blip, SearchBar, HeaderComponent, TransactionTable } from "../../components";
import { withRouter } from "react-router-dom";
import { Colors } from "../../config";
import { TransactionAction } from "../../store/actions";
import {
  RiSearchLine,
  RiCheckLine,
  RiArrowDropDownLine,
  RiArrowDropUpLine,
} from "react-icons/ri";
import "../../index.css";
const { Option } = Select;
class Transactions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userSelectType: "event manager",
      offset: 0,
      like: "",
      isUserTypeClicked: false,
      isStatusClicked: false,
      isUserTypeSecondClicked: false,
      current: 1,
    };
  }
  handleSearch = (val) => {
    const { gettransactions } = this.props;
    gettransactions(0, 10, val, "");
    this.setState({ like: val, current: 1, offset: 0 });
  };
  componentDidMount() {
    const { gettransactions } = this.props;
    gettransactions(0, 10, "", "");
  }

  handlePages = (pageNumber) => {
    const limit = 10;
    let offset = (pageNumber - 1) * limit;
    const { gettransactions } = this.props;
    const { like } = this.state;
    gettransactions(offset, limit, like, "");
    this.setState({ offset: offset, current: pageNumber });
  };

  render() {
    const userType = this.state.userType;
    const { transactions, transactioncount } = this.props;
    const { offset, userSelectType, like, current, userStatus } = this.state;
    return (
      <HeaderComponent>
        <Row gutter={[0, 20]} style={{ padding: 40 }}>
        <Col span={24}>
            <Row gutter={[0, 10]}>
              <Col xs={24} sm={24} md={14} lg={14} xl={14} align="start">
                <Row>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <h1>
                      <b>Transactions </b>
                    </h1>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={24} md={10} lg={10} xl={10}>
                <Row justify="center" gutter={[15, 10]}>
                  <Col xs={24} sm={24} md={9} lg={9} xl={9}></Col>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                    <SearchBar
                      placeholder="Search here"
                      prefix={
                        <RiSearchLine style={{ color: Colors.Primary }} />
                      }
                      onChange={(e) => {
                        //console.log("E VALUE E is: ", e.target.value);
                        this.handleSearch(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          <Col span={24} style={{ padding: 30 }}>
            <Row
              style={{
                boxShadow: "0px 5px 20px #1E1E2214",
                borderRadius: "10px",
              }}
            >
              <TransactionTable
                transactionData={transactions}
                limit={10}
                offset={offset}
                typee={userSelectType}
                like={like}
                userStatus={userStatus}
              />
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="center">
              <Pagination
                responsive="true"
                showLessItems="true"
                current={current}
                pageSize={10}
                total={transactioncount ? transactioncount : 0}
                onChange={(e) => {
                  this.handlePages(e);
                }}
              />
            </Row>
          </Col>
        </Row>
      </HeaderComponent>
    );
  }
}

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    gettransactions: (offset, limit, like, status) => {
      dispatch(TransactionAction.GetTransactions(offset, limit, like, status));
    },
  };
}

export default withRouter(
  connect(
    (storeState) => ({
      transactioncount: storeState.TransactionReducer.transactioncount,
      transactions: storeState.TransactionReducer.transactions
    }),
    (mapStateToProps, mapDispatchToProps)
  )(Transactions)
);
